export function openMessenger() {
  if (window.HubSpotConversations?.widget) {
    window.HubSpotConversations.widget.open();
  }
}
